import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth, arrowWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_BLUE, TRACK_DIFFICULTY_RED } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

const renderLabel = (coords, color, onLabelClick) => (
	<Label
		onClick={(event, ref) => onLabelClick(event, ref, 'Track1CBlue')}
		coords={coords}
		text="1C"
		textCoordsX="11.3564453"
		colors={color}
	/>
);

const Track1CBlue = ({ state, workState, onLabelClick }) => (
	<g id="Track1CBlue" transform="translate(800.000000, 728.000000)" className="track">
		<g id="line" transform="translate(0.000033, -0.000013)"
			 stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}
			 strokeLinecap="round"
			 strokeWidth={tracksWidth}
		>
			<path
				d="M34.0259666,323.407313 L8.0069666,306.036313 C-0.261033402,300.515313 -2.4880334,289.339313 3.0319666,281.071313 C3.8399666,279.860313 4.7919666,278.753313 5.8659666,277.771313 L55.4999666,231.500013"/>

			<TrackArrow
				transform="translate(31.999967, 322.000013) rotate(-145.000000) translate(-31.999967, -322.000013) "
				points="35.9999666 330.000013 27.9999666 322.000013 35.9999666 314.000013"/>

			<path
				d="M289.954804,323.340926 L102.852967,399.049313 C98.4059666,400.844313 93.3459666,398.693313 91.5519666,394.247313 C90.6679666,392.057313 90.7139666,389.602313 91.6789666,387.447313 C96.7659666,376.093313 92.9149666,362.724313 82.5679666,355.815313 L44.7819666,330.589313"/>
		</g>

		{renderLabel("137.430530, 361.229746",
			getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE),
			onLabelClick
		)}

		{renderLabel("67.430530, 185.229746",
			getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE),
			onLabelClick
		)}

		{renderLabel("154.430530, 37.229746",
			getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE),
			onLabelClick
		)}
	</g>
);

Track1CBlue.propTypes = trackPropTypes;

export default Track1CBlue;
